import {AfterViewInit, Component, EventEmitter, forwardRef, HostBinding, Input, OnInit, Output} from '@angular/core';
import {AbstractSwitchesComponent} from 'app/core/switches.component';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {SwitchRadioCollection} from 'app/entities/switchCollection.entity';

@Component({
  selector: 'app-segment-wrapper',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SegmentWrapperComponent),
      multi: true
    }
  ]
})
export class SegmentWrapperComponent extends AbstractSwitchesComponent<SwitchRadioCollection> implements OnInit, AfterViewInit {
  @Input() labelText?: string = null;
  @Input() style?: 'default' | 'secondary' = 'default';

  @Input() size: 'medium' | 'large' = 'medium';
  @Input() state: 'success' | 'error';
  @Input() showErrorElement = true;
  @Input() clearInput: boolean;
  @Input() errorText: string;
  @Input() requiredLabel = false;

  @Input() errorTextPosition: 'left' | 'right' | 'center' = 'left';
  @Output() loaded = new EventEmitter();

  writeValue(value): void {
    this._value = value;

    if (value) {
      this.collection.itemSelect(value);
    }

    setTimeout(() => this.cdRef.detectChanges(), 0);
  }

  @HostBinding('class')
  get classes() {
    return {
      [`input-state-${this.state}`]: this.state,
      [`input-size-${this.size}`]: this.size,
      'input-disabled': this.disabled
    };
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.loaded.emit();
  }
}
